import { Injectable, inject } from '@angular/core'

import type { Observable } from 'rxjs'
import { map } from 'rxjs'

import { ApiService } from '../../api/api.service'
import type { PageDto } from '../../api/responses'

@Injectable({
  providedIn: 'root',
})
export class PagesService {
  private readonly api = inject(ApiService)

  getPageBySlug(slug: string, locale: string): Observable<PageDto | null> {
    return this.api
      .getPageBySlug(slug, locale)
      .pipe(map(response => response.data.Pages.docs[0] ?? null))
  }
}
